import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import { MenuItem } from '@mui/material';
import { DataService } from '../../../services';
import { Dialog, TabsHeader } from '../../../components';
import { withRouter } from 'react-router-dom';
import { PropertiesTab } from '../../baseClasses/PropertiesTab';
import { Trans } from 'react-i18next';
import { ModalVariants } from '../../../common/types';
import { itemIcons } from '../../../common/constants';
import { storeOpenModal } from '../../../store/actions/modal';
import { Dispatch, Action } from 'redux';
import {
  ViewBase,
  ViewBaseStyles,
  ViewBaseProps,
  ViewBaseState,
  ViewBaseMapDispatchToProps,
} from '../../baseClasses/ViewBase';
import i18next from 'i18next';
import dataSchema from '../../../assets/schemas/data.schema.parsed.json';

type _Props = {
  openModal: (callback: () => void) => () => void;
};
type Props = ViewBaseProps<_Props, { trustId: string }>;

type _State = Record<string, unknown>;
type State = ViewBaseState<_State>;

class TrustDetailedView extends ViewBase<Props, State, { trustId: string }> {
  state: State = {
    loading: false,
    activeTab: 0,
    item: undefined,
    deleteDialogOpen: false,
  };
  propertyTab!: number;
  dataService!: DataService;

  constructor(props: Props) {
    super(props);
    this.tabs = ['tab.properties'];
    DataService.create().then((service) => (this.service = service));
    this.subservice = 'trust';
    this.messages = {
      load: { error: 'error.fetch.deviceApi' },
      update: { success: 'success.update.deviceApiGw', error: 'error.tryAgain' },
      delete: { success: 'success.delete.deviceApiGw', error: 'error.tryAgain' },
    };
  }

  renderTabsHeaderMenuItems = (): React.ReactNode[] | undefined => {
    const list: React.ReactNode[] = [];
    if (!this.accessControl) return undefined;
    if (this.accessControl('trust', 'delete'))
      list.push(
        <MenuItem key="1" disabled={!this.state.item} onClick={() => this.setState({ deleteDialogOpen: true })}>
          <Trans>action.delete</Trans>
        </MenuItem>,
      );
    return list;
  };

  renderTabs = (): React.ReactNode => (
    <>
      <PropertiesTab
        tab={0}
        activeTab={this.state.activeTab}
        accessControl={this.accessControl}
        accessControlSection="deviceApiGw"
        parentLoading={this.state.loading}
        schema={dataSchema}
        schemaKey={'trust' + this.state.item?.type}
        item={this.state.item}
        update={this.update}
        reload={this.load}
      />
    </>
  );

  renderDialogs = (): React.ReactNode => (
    <>
      <Dialog
        open={this.state.deleteDialogOpen}
        title={<Trans>action.delete</Trans>}
        description={<Trans>description.delete.deviceApiGw</Trans>}
        continueTitle={<Trans>action.delete</Trans>}
        onClose={() => this.setState({ deleteDialogOpen: false })}
        onContinue={this.delete}
      />
    </>
  );

  render = (): React.ReactNode => (
    <div className={this.props.classes.root}>
      <TabsHeader
        title={this.props.match.params.trustId}
        icon={itemIcons.trust}
        subtitle={i18next.t('form.trustId')}
        tabIndex={this.state.activeTab}
        onChangeTab={this.changeTab}
        tabs={this.tabs}
        menuItems={this.renderTabsHeaderMenuItems()}
      >
        {this.renderTabs()}
      </TabsHeader>
      {this.renderDialogs()}
    </div>
  );
}

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  openModal: (callback: () => void) => () =>
    dispatch(storeOpenModal(ModalVariants.AddDeviceGroupsToDeviceMC, { callback })),
  ...ViewBaseMapDispatchToProps(dispatch),
});

export default withStyles(ViewBaseStyles)(withRouter(connect(null, mapDispatchToProps)(TrustDetailedView)));
